<script lang="ts">
	import { Config } from '#lib/constants/config.js';
	import { NewsletterCard } from '#lib/features/newsletter/components/NewsletterCard/index.js';
	import { NewsletterProvenance } from '#lib/features/newsletter/constants/mixpanel-events.js';
</script>

<NewsletterCard
	dataCy="home-newsletter"
	title="Stay in the loop"
	intro="Get HENI updates about new releases, exhibitions and art news."
	provenance={NewsletterProvenance.Home}
	listId={Config.NewsletterListIds.Shop}
/>
